import { useEffect, useState } from "react";
import Avatar from "../../fragments/Avatar";
import useWebSocket from "../../hooks/useWebSocket";

const PlayerList = () => {
  const [onlinePlayers, setOnlinePlayers] = useState([]);
  const { sendJson } = useWebSocket({
    messageType: "online_players",
    onMessage(data) {
      setOnlinePlayers(data.online_players);
    },
  });

  useEffect(() => {
    sendJson({ type: "get_players" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <h2 className="my-2 p-4 sm:px-6 pb-0 text-lg tracking-tight">
        <span>Online Players</span>
        <span className="text-gray-600 pl-2">{onlinePlayers.length}</span>
      </h2>
      <div className="overflow-y-auto overflow-x-hidden max-h-[40vh] pl-4 sm:pl-6 pt-0">
        {onlinePlayers.map((user, i) => (
          <a
            key={i}
            href="#user"
            className="group flex items-center justify-start gap-x-2 py-1"
          >
            <Avatar user={user} className="h-8 w-8" />
            <span className="font-medium group-hover:decoration-2 max-w-full text-ellipsis overflow-hidden">
              {user.username}
            </span>
          </a>
        ))}
      </div>
    </>
  );
};

export default PlayerList;
